// extracted by css-extract-rspack-plugin
export default {"list":"Items-module__list__OXh8h"};